// removed by extract-text-webpack-plugin
module.exports = {"label":"_1LQwBvqv-UwyT2Xw2Pd8Wf"};


//////////////////
// WEBPACK FOOTER
// ./src/client/Components/Forms/Label/Label.css
// module id = 1002
// module chunks = 58